/** Random Shorts — Product Experience Elite v3
 * Sin dependencias externas. Funciona con Shopify Ajax Cart API y con fallback nativo.
 * No modifica el checkout ni presupone que el drawer de Shrine escucha eventos propios.
 */
(() => {
  'use strict';
  const ROOT_SELECTOR = '[data-rsp-root]';
  const parseJSON = (element, fallback) => {
    if (!element) return fallback;
    try { return JSON.parse(element.textContent); } catch (_) { return fallback; }
  };
  const rootPath = () => {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && root.startsWith('/') ? root : '/';
  };
  const money = (cents, currency) => {
    const amount = Number(cents) / 100;
    if (!Number.isFinite(amount)) return '—';
    try {
      return new Intl.NumberFormat('es-UY', {
        style: 'currency', currency: currency || 'UYU',
        minimumFractionDigits: 0, maximumFractionDigits: 2
      }).format(amount);
    } catch (_) {
      return '$ ' + new Intl.NumberFormat('es-UY').format(amount);
    }
  };

  function init(root) {
    if (root.dataset.rspReady === 'true') return;
    root.dataset.rspReady = 'true';
    const $ = selector => root.querySelector(selector);
    const $$ = selector => Array.from(root.querySelectorAll(selector));
    const form = $('[data-rsp-product-form]');
    if (!form) return;

    const variants = parseJSON($('[data-rsp-variants]'), []);
    const variantMap = new Map(variants.map(v => [String(v.id), v]));
    const trivia = parseJSON($('[data-rsp-trivia]'), null);
    const packRadios = $$('input[type="radio"][name^="rsp-pack-"]');
    const rows = $$('[data-rsp-unit]');
    const selects = $$('[data-rsp-variant]');
    const price = $('[data-rsp-price]');
    const total = $('[data-rsp-total]');
    const unitsCount = $('[data-rsp-units-count]');
    const stock = $('[data-rsp-stock]');
    const addCheck = $('[data-rsp-addon-check]');
    const submit = $('[data-rsp-submit]');
    const label = $('[data-rsp-submit-label]');
    const feedback = $('[data-rsp-form-msg]');
    const progressTitle = $('[data-rsp-dac-title]');
    const progressCaption = $('[data-rsp-dac-caption]');
    const progressFill = $('[data-rsp-dac-fill]');
    const bar = $('[data-rsp-mobile-bar]');
    const mobileButton = $('[data-rsp-mobile-submit]');
    const mobilePrice = $('[data-rsp-mobile-price]');
    const mobileCount = $('[data-rsp-mobile-count]');
    const success = $('[data-rsp-success]');
    const successMessage = $('[data-rsp-success-msg]');
    const currency = root.dataset.currency || 'UYU';
    const threshold = Math.max(0, Number(root.dataset.threshold) || 200000);
    let cartTotal = 0;
    let busy = false;

    const quantity = () => {
      const selected = packRadios.find(radio => radio.checked);
      return Math.min(3, Math.max(1, Number(selected && selected.value) || 1));
    };
    function pickedVariants() {
      return selects.slice(0, quantity()).map(select => variantMap.get(String(select.value)));
    }
    function selectedPrice() {
      return pickedVariants().reduce((sum, v) => sum + (v ? Number(v.price) || 0 : 0), 0)
        + (addCheck && addCheck.checked && trivia ? Number(trivia.price) || 0 : 0);
    }
    function checkSelections() {
      const counts = new Map();
      for (const variant of pickedVariants()) {
        if (!variant || variant.available !== true) return {ok: false, message: 'Elegí un talle disponible para cada short'};
        const key = String(variant.id);
        counts.set(key, (counts.get(key) || 0) + 1);
      }
      for (const [id, count] of counts) {
        const v = variantMap.get(id);
        if (v && v.inventory_management === 'shopify' && v.inventory_policy !== 'continue'
          && v.inventory_quantity != null && Number.isFinite(Number(v.inventory_quantity)) && count > Number(v.inventory_quantity)) {
          return {ok: false, message: `No hay suficientes unidades del talle ${v.title} para ese pack. Elegí otro talle o reducilo`};
        }
      }
      if (addCheck && addCheck.checked && (!trivia || trivia.available !== true)) {
        return {ok: false, message: 'Mega Trivia no está disponible para sumar en este momento'};
      }
      return {ok: true, message: ''};
    }
    function setMessage(message, isSuccess = false) {
      feedback.textContent = message;
      feedback.classList.toggle('is-success', isSuccess);
    }
    function ensureAvailableSelects() {
      selects.forEach(select => {
        if (!select.options.length) return;
        const option = select.selectedOptions[0];
        if (!option || option.disabled) {
          const available = Array.from(select.options).find(opt => !opt.disabled);
          if (available) select.value = available.value;
        }
      });
    }
    function refreshProgress() {
      const projected = cartTotal + selectedPrice();
      const gap = Math.max(0, threshold - projected);
      progressFill.style.width = `${Math.min(100, Math.max(0, projected / threshold * 100))}%`;
      if (gap === 0) {
        progressTitle.textContent = 'CON ESTA SELECCIÓN, ALCANZÁS EL UMBRAL DAC';
        progressCaption.textContent = 'Beneficio sujeto al total final del pedido';
      } else {
        progressTitle.textContent = `TE FALTARÍAN ${money(gap, currency)} PARA QUE RANDOM CUBRA DAC`;
        progressCaption.textContent = 'Estimado sumando tu carrito y esta selección';
      }
    }
    function refresh() {
      ensureAvailableSelects();
      const qty = quantity();
      rows.forEach((row, index) => { row.hidden = index >= qty; });
      $$('[data-rsp-unit] select').forEach((select, index) => { select.disabled = index >= qty; });
      packRadios.forEach(radio => radio.closest('.rsp-pack').classList.toggle('is-active', radio.checked));
      const selection = pickedVariants();
      const current = selection[0];
      if (current) price.textContent = money(current.price, currency);
      total.textContent = money(selectedPrice(), currency);
      unitsCount.textContent = `${qty} ${qty === 1 ? 'short' : 'shorts'}`;
      const checked = checkSelections();
      stock.textContent = checked.ok ? 'Los talles seleccionados están disponibles' : checked.message;
      stock.classList.toggle('is-error', !checked.ok);
      const disable = busy || !checked.ok;
      submit.disabled = disable;
      mobileButton.disabled = disable;
      if (!busy) label.textContent = checked.ok ? 'AGREGAR MI EXPERIENCIA' : 'REVISÁ LOS TALLES';
      if (mobilePrice) mobilePrice.textContent = money(selectedPrice(), currency);
      if (mobileCount) mobileCount.textContent = `${qty} ${qty === 1 ? 'SHORT' : 'SHORTS'}`;
      refreshProgress();
    }
    const showSticky = () => {
      if (!bar || !window.matchMedia('(max-width: 650px)').matches) {
        if (bar) bar.hidden = true;
        root.classList.remove('rsp-mobile-active');
        return;
      }
      const r = submit.getBoundingClientRect();
      const visible = r.top > window.innerHeight || r.bottom < 0;
      bar.hidden = !visible;
      root.classList.toggle('rsp-mobile-active', visible);
    };

    async function loadCart() {
      const response = await fetch(rootPath() + 'cart.js', {headers: {'Accept': 'application/json'}, credentials: 'same-origin'});
      if (!response.ok) throw new Error('No se pudo consultar el carrito');
      const cart = await response.json();
      cartTotal = Number(cart.total_price) || 0;
      refreshProgress();
      return cart;
    }
    function syncHeaderCart(cart) {
      // Adaptado a #cart-icon-bubble de Shrine; no sustituye el drawer del tema.
      const header = document.getElementById('cart-icon-bubble');
      if (!header) return;
      const amount = Number(cart.item_count) || 0;
      const bubble = header.querySelector('.cart-count-bubble');
      if (amount < 1) { if (bubble) bubble.remove(); return; }
      if (!bubble) {
        const node = document.createElement('div');
        node.className = 'cart-count-bubble';
        const number = document.createElement('span');
        number.setAttribute('aria-hidden', 'true');
        number.textContent = amount < 100 ? String(amount) : '';
        node.appendChild(number);
        const sr = document.createElement('span');
        sr.className = 'visually-hidden';
        sr.textContent = `${amount} artículos en el carrito`;
        node.appendChild(sr);
        header.appendChild(node);
      } else {
        const number = bubble.querySelector('[aria-hidden="true"]');
        if (number) number.textContent = amount < 100 ? String(amount) : '';
        const sr = bubble.querySelector('.visually-hidden');
        if (sr) sr.textContent = `${amount} artículos en el carrito`;
      }
    }
    async function addToCart(event) {
      if (event) event.preventDefault();
      if (busy) return;
      refresh();
      const valid = checkSelections();
      if (!valid.ok) { setMessage(valid.message); feedback.scrollIntoView({block: 'center', behavior: 'smooth'}); return; }
      busy = true;
      submit.disabled = true;
      mobileButton.disabled = true;
      label.textContent = 'AGREGANDO TU EXPERIENCIA…';
      setMessage('');
      const variantCounts = new Map();
      for (const variant of pickedVariants()) {
        const id = String(variant.id);
        variantCounts.set(id, (variantCounts.get(id) || 0) + 1);
      }
      const items = Array.from(variantCounts, ([id, count]) => ({id: Number(id), quantity: count}));
      if (addCheck && addCheck.checked && trivia && trivia.available === true) {
        items.push({id: Number(trivia.id), quantity: 1});
      }
      try {
        const response = await fetch(rootPath() + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
          body: JSON.stringify({items})
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || result.message || 'No se pudo agregar la selección al carrito');
        }
        setMessage('Tu selección se agregó al carrito', true);
        const qty = quantity();
        successMessage.textContent = `Sumaste ${qty} ${qty === 1 ? 'short' : 'shorts'}${addCheck && addCheck.checked ? ' y Mega Trivia' : ''} a tu pedido`;
        success.hidden = false;
        try { const cart = await loadCart(); syncHeaderCart(cart); }
        catch (_) { /* El agregado tuvo éxito; un fallo del refresco no anula la compra */ }
      } catch (error) {
        const detail = typeof error.message === 'string' ? error.message : 'No se pudo agregar el pedido';
        setMessage(detail);
        success.hidden = true;
      } finally {
        busy = false;
        refresh();
        showSticky();
      }
    }

    packRadios.forEach(radio => radio.addEventListener('change', () => {setMessage('');refresh();}));
    selects.forEach(select => select.addEventListener('change', () => {
      setMessage('');
      // Mantener enlaces profundos correctos cuando se compra una sola unidad.
      if (quantity() === 1 && select === selects[0]) {
        try {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', select.value);
          window.history.replaceState(window.history.state, '', url);
        } catch (_) { /* La selección sigue funcional aunque history esté bloqueado */ }
      }
      refresh();
    }));
    if (addCheck) addCheck.addEventListener('change', () => {setMessage('');refresh();});
    form.addEventListener('submit', addToCart);
    if (mobileButton) mobileButton.addEventListener('click', () => {if (typeof form.requestSubmit === 'function') form.requestSubmit(submit); else submit.click();});
    $('[data-rsp-dismiss]')?.addEventListener('click', () => {success.hidden = true;});


  // Pausar siempre el medio anterior; los reproductores externos se descargan al salir.
  function stopInactiveMedia(slide) {
    slide.querySelectorAll('video').forEach(video => {
      if (!video.paused) video.pause();
    });
    slide.querySelectorAll('iframe').forEach(frame => {
      const src = frame.getAttribute('src');
      if (src && frame.dataset.rspActivated === 'true') {
        frame.setAttribute('src', src); // Detiene audio/video también en YouTube y Vimeo.
        frame.dataset.rspActivated = 'false';
      }
    });
  }
    // Galería con navegación por thumbnails y flechas.
    const slides = $$('[data-rsp-slide]');
    const thumbnails = $$('[data-rsp-thumb]');
    let galleryIndex = 0;
    function showMedia(index) {
      if (!slides.length) return;
      galleryIndex = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.hidden = i !== galleryIndex;
        slide.classList.toggle('is-hidden', i !== galleryIndex);
        if (i !== galleryIndex) stopInactiveMedia(slide);
        else slide.querySelectorAll('iframe').forEach(frame => { frame.dataset.rspActivated = 'true'; });
      });
      thumbnails.forEach((thumb, i) => {
        thumb.classList.toggle('is-active', i === galleryIndex);
        thumb.setAttribute('aria-pressed', String(i === galleryIndex));
      });
      const count = $('[data-rsp-gallery-count]');
      if (count) count.textContent = `${String(galleryIndex + 1).padStart(2, '0')} / ${String(slides.length).padStart(2, '0')}`;
    }
    slides[0]?.querySelectorAll('iframe').forEach(frame => { frame.dataset.rspActivated = 'true'; });
    thumbnails.forEach(t => t.addEventListener('click', () => showMedia(Number(t.dataset.rspThumb))));
    $('[data-rsp-gallery-prev]')?.addEventListener('click', () => showMedia(galleryIndex - 1));
    $('[data-rsp-gallery-next]')?.addEventListener('click', () => showMedia(galleryIndex + 1));

    const dialog = $('[data-rsp-size-dialog]');
    $('[data-rsp-open-size]')?.addEventListener('click', () => {
      if (dialog && dialog.showModal) dialog.showModal();
      else if (dialog) dialog.setAttribute('open', '');
    });
    $('[data-rsp-close-size]')?.addEventListener('click', () => {
      if (dialog && dialog.close) dialog.close();
      else if (dialog) dialog.removeAttribute('open');
    });
    dialog?.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
    window.addEventListener('resize', showSticky, {passive: true});
    window.addEventListener('scroll', showSticky, {passive: true});
    refresh();
    showSticky();
    loadCart().catch(() => { /* No bloquear checkout si falla lectura del carrito */ });
  }
  function initAll(context = document) {
    if (context.matches && context.matches(ROOT_SELECTOR)) init(context);
    context.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', event => initAll(event.target));
})();
